/** DOM id of the navbar AI-processing trigger button. */
export const AI_PROCESSING_TRIGGER_ID = 'ai-processing-trigger';
